// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/image/error404.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/image/logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ovt6ynt.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&family=Oswald:wght@200;300;400;500;600;700&family=Roboto+Condensed:wght@300;400;700&family=Roboto:wght@100;300;400;500;700;900&family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&family=Spectral:wght@200;300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";


.error {
    display: flex;
    /* justify-content: space-evenly; */
    justify-content: center;
    align-items: center;
    height: 100vh;
    gap: 80px;
}

.error__message {
    text-align: center;
    color: #FFFFFF;
}

.message__title {
    font-family: 'Ubuntu';
    font-weight: 300;
    font-size: 200px;
    letter-spacing: 1rem;
    padding-bottom: 15px;
    margin: 0 auto;
}

.message__text {
    display: flex;
    justify-content: center;
    text-align: center;
    font-family: 'Ubuntu';
    line-height: 25px;
    font-weight: 500;
    font-size: 20px;
    margin: auto;
    letter-spacing: .1rem;
    color: #FFFFFF;
    width: 20em;
}

.button_error {
    display: flex;
    justify-content: center;
}

.e-nav__link {
    height: 45px;
    line-height: 45px;
    width: 255px;
    font-family: 'Ubuntu';
    color: #FFFFFF;
    border-radius: 25px;
    background: #001767;
    text-align: center;
    font-size: 15px;
    letter-spacing: .1rem;
}


.e-nav__link:before,
a:hover {
    text-decoration: none;
    box-shadow: 0px 3px 3px 1px #131414;
    color: #fff;
}

.lamp {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    align-items: center;
    width: 30em;
    height: 40em;
    max-width: 100vw;
    max-height: 100vh;
    object-fit: cover;
}

.img-logo-error {
    margin: 4px 0 46px 0;
    padding: 40px;
    color: #EBCE2C;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 100% 100%;
}

@media (max-width: 950px) {
    .lamp {
        width: 25em;
        height: 31.25em;
        max-width: 100vw;
        max-height: 75vh;
        object-fit: cover;
    }

    .error {
        gap: 0px;
    }
}

@media (max-width: 750px) {
    .error {
        flex-direction: column;
        height: 100vh;
    }

    .lamp {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/error-page/error-page.css"],"names":[],"mappings":"AAAA,gBAAgB;;;AAKhB;IACI,aAAa;IACb,mCAAmC;IACnC,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;;AAGA;;IAEI,qBAAqB;IACrB,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,yDAAsD;IACtD,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,cAAc;IACd,yDAAkD;IAClD,0BAA0B;AAC9B;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://use.typekit.net/ovt6ynt.css\");\n@import url(\"https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&family=Oswald:wght@200;300;400;500;600;700&family=Roboto+Condensed:wght@300;400;700&family=Roboto:wght@100;300;400;500;700;900&family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&family=Spectral:wght@200;300;400;500;600;700;800&display=swap\");\n\n\n.error {\n    display: flex;\n    /* justify-content: space-evenly; */\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    gap: 80px;\n}\n\n.error__message {\n    text-align: center;\n    color: #FFFFFF;\n}\n\n.message__title {\n    font-family: 'Ubuntu';\n    font-weight: 300;\n    font-size: 200px;\n    letter-spacing: 1rem;\n    padding-bottom: 15px;\n    margin: 0 auto;\n}\n\n.message__text {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    font-family: 'Ubuntu';\n    line-height: 25px;\n    font-weight: 500;\n    font-size: 20px;\n    margin: auto;\n    letter-spacing: .1rem;\n    color: #FFFFFF;\n    width: 20em;\n}\n\n.button_error {\n    display: flex;\n    justify-content: center;\n}\n\n.e-nav__link {\n    height: 45px;\n    line-height: 45px;\n    width: 255px;\n    font-family: 'Ubuntu';\n    color: #FFFFFF;\n    border-radius: 25px;\n    background: #001767;\n    text-align: center;\n    font-size: 15px;\n    letter-spacing: .1rem;\n}\n\n\n.e-nav__link:before,\na:hover {\n    text-decoration: none;\n    box-shadow: 0px 3px 3px 1px #131414;\n    color: #fff;\n}\n\n.lamp {\n    background-image: url(../../assets/image/error404.png);\n    background-size: 100% 100%;\n    align-items: center;\n    width: 30em;\n    height: 40em;\n    max-width: 100vw;\n    max-height: 100vh;\n    object-fit: cover;\n}\n\n.img-logo-error {\n    margin: 4px 0 46px 0;\n    padding: 40px;\n    color: #EBCE2C;\n    background-image: url(../../assets/image/logo.svg);\n    background-size: 100% 100%;\n}\n\n@media (max-width: 950px) {\n    .lamp {\n        width: 25em;\n        height: 31.25em;\n        max-width: 100vw;\n        max-height: 75vh;\n        object-fit: cover;\n    }\n\n    .error {\n        gap: 0px;\n    }\n}\n\n@media (max-width: 750px) {\n    .error {\n        flex-direction: column;\n        height: 100vh;\n    }\n\n    .lamp {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
